export enum PermissoesEnum {
    LEITURA = 'LEITURA',
    ESCRITA = 'ESCRITA',
}